import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from 'axios';
import config from '../config/config';
import './SupportTicketDetails.css';

const SupportTicketDetails = () => {
  const { ticketId } = useParams();
  const history = useHistory();
  const [ticket, setTicket] = useState(null);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  const statusOptions = [
    { value: 1, label: 'New' },
    { value: 2, label: 'In Progress' },
    { value: 3, label: 'On Hold' },
    { value: 4, label: 'Closed' }
  ];

  useEffect(() => {
    const fetchTicketDetails = async () => {
      try {
        const token = localStorage.getItem('superAdminToken');
        if (!token) {
          history.push('/login');
          return;
        }

        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        const response = await axios.get(`${config.serverUrl}/support/tickets/${ticketId}`);
        setTicket(response.data.ticket);
        setComments(response.data.comments.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
      } catch (error) {
        setError('Failed to fetch support ticket details. Please try again later.');
        console.error('Failed to fetch support ticket details:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchTicketDetails();
  }, [ticketId, history]);

  const handleAddComment = async () => {
    try {
      const token = localStorage.getItem('superAdminToken');
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      await axios.post(`${config.serverUrl}/support/tickets/${ticketId}/comments`, { comment: newComment });
      setComments([{ comment: newComment, createdAt: new Date() }, ...comments]);
      setNewComment('');
    } catch (error) {
      setError('Failed to add comment. Please try again later.');
      console.error('Failed to add comment:', error);
    }
  };

  const handleStatusChange = async (event) => {
    const status = event.target.value;
    try {
      const token = localStorage.getItem('superAdminToken');
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      await axios.patch(`${config.serverUrl}/support/tickets/${ticketId}`, { status });

      const response = await axios.get(`${config.serverUrl}/support/tickets/${ticketId}`);
      setTicket(response.data.ticket);
      setComments(response.data.comments.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));      
    } catch (error) {
      setError('Failed to change status. Please try again later.');
      console.error('Failed to change status:', error);
    }
  };

  const handleBackClick = () => {
    history.goBack();
  };

  if (isLoading) {
    return <div className="loading">Loading...</div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <div className="support-ticket-details-container">
      <h1>Support Ticket Details</h1>
      <button className="back-button" onClick={handleBackClick}>Back</button>
      <div className="ticket-details">
        <p><strong>ID:</strong> {ticket.id}</p>
        <p><strong>Account:</strong> {ticket.accountId} {ticket.accountName}</p>
        <p><strong>Domain Name:</strong> {ticket.domainName}</p>
        <p><strong>Username:</strong> {ticket.username}</p>                
        <p><strong>PhoneNumber:</strong> {ticket.phone}</p>
        <p><strong>Email:</strong> {ticket.email}</p>
        <p><strong>Subject:</strong> {ticket.subject}</p>        
        <p><strong>Description:</strong> </p>
        <div className="ticket-description"> {ticket.description}</div>        
        <p><strong>Status:</strong> 
          <select value={ticket.status} onChange={handleStatusChange}>
            {statusOptions.map(option => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
        </p>
        <p><strong>Date Created:</strong> {new Date(ticket.createdAt).toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' })}</p>
      </div>
      <div className="comments-section">
        <h2>Comments</h2>
        <textarea 
          value={newComment} 
          onChange={(e) => setNewComment(e.target.value)} 
          placeholder="Add a comment..."
        ></textarea>
        <button onClick={handleAddComment}>Add Comment</button>
        <ul>
          {comments.map((comment, index) => (            
            <li key={index}>
              <div className="comment-user">
                <strong>{comment.username}</strong> {new Date(comment.createdAt).toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' })}
              </div>
              <div className="comment-text">{comment.comment}</div>
            </li>            
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SupportTicketDetails;
